// ThaiDatepickerHeader.tsx

import React from 'react';

interface ThaiDatepickerHeaderProps {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  language: string;
}

const ThaiDatepickerHeader: React.FC<ThaiDatepickerHeaderProps> = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  language,
}) => {
  const month = date.toLocaleString(language, { month: 'long' });
  const year = date.getFullYear();
  const buddhistYear = year + 543; // Thai Buddhist year adjustment

  return (
    <div className="react-datepicker__header">
      <button
        type="button"
        className="react-datepicker__navigation react-datepicker__navigation--previous"
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        aria-label="Previous Month"
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
          {'<'}
        </span>
      </button>

      <h2 className="react-datepicker__current-month">{`${month} ${buddhistYear}`}</h2>

      <button
        type="button"
        className="react-datepicker__navigation react-datepicker__navigation--next"
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        aria-label="Next Month"
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
          {'>'}
        </span>
      </button>
    </div>
  );
};

export default ThaiDatepickerHeader;
